<template>
    <div style="width: 100%; text-align:right;">
      <v-icon @click="$parent.addNew(null)" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
      <table v-if="!$root.device.isMobile" class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
        <tr class="trPrint trHeader">
          <th class="tdData sp" style="width: 120px;">תמונה</th>
          <th class="tdData">שם פרויקט</th>
          <th class="tdData">ישוב</th>
          <th class="tdData">כתובת</th>
          <th class="tdData">שלב התקדמות</th>
          <th class="tdData">תאריך התחלה</th>
          <th class="tdData">תאריך סיום</th>
          <th class="tdData">אחוז התקדמות</th>
          <th class="tdData">יזם</th>
          <!--<th class="tdData">תאריך עדכון</th>-->
          <th class="tdCtrl" style="width: 160px!important;"></th>
        </tr>
      </table>
      <div class="scrollContent" v-if="$parent.hasData">
        <table  v-if="!$root.device.isMobile" class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
          <tr v-for="row in $parent.filteredRows" :class="{ 'trSelect': row.selected }">
            <td class="tdData sp" style="position:relative; width: 120px;">
              <img v-if="row.Images" class="thumb" style="cursor: pointer;" :src="row.Images[0]" @click="$parent.edit(row)" @error="imageError(row)"/>
              <img v-else class="thumb" src="../assets/no_image.png" style="cursor: pointer;" @click="$parent.edit(row)" @error="imageError(row)"/>
            </td>
            <td class="tdData tdTxt">{{row.Name}}</td>
            <td class="tdData tdTxt">{{row.City}}</td>
            <td class="tdData tdTxt">{{row.Address}}</td>
            <td class="tdData tdTxt">
              <div class="divColorIcon" :style="{ 'background-color': $parent.getStatusColor(row.StatusKey) }"></div>
              <div style="line-height: 30px;">{{$parent.getStatusName(row.StatusKey)}}</div>
            </td>
            <td class="tdData tdTxt">{{row.StartDate}}</td>
            <td class="tdData tdTxt">{{row.EndDate}}</td>
            <td class="tdData tdTxt">
              <v-progress-circular :size="50" :width="5" :rotate="360" :value="row.Percent" color="black" style="color: #F7941D">
                {{ row.Percent }}%
              </v-progress-circular>
            </td>
            <td class="tdData tdTxt">
              <span v-if="row.Entrepreneur">{{row.Entrepreneur.FullName}}</span>
            </td>
            <td class="tdCtrl tdTxt" style="width: 160px!important;">
              <v-icon @click="$parent.edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
              <v-icon @click="$parent.confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
            </td>
          </tr>
        </table>
        <div v-else>
          <v-card class="cardDiary cardDiaryMobile w3-table-all" v-for="row in $parent.filteredRows">
            <v-container grid-list-lg>
              <v-layout row>
                <v-flex xs5>
                  <img v-if="row.Images" class="thumb" style="cursor: pointer;" :src="row.Images[0]" @click="$parent.edit(row)" @error="imageError(row)" />
                  <img v-else class="thumb" src="../assets/no_image.png" style="cursor: pointer;" @click="$parent.edit(row)" @error="imageError(row)" />
                </v-flex>
                <v-flex xs7>
                  <div style="padding-right: 10px;">
                    <div style="text-align: right;"><b>{{row.Name}}</b></div>
                    <div style="text-align: right;">{{row.City}}</div>
                    <div style="text-align: right;">{{row.Address}}</div>
                    <div style="text-align: right;">{{row.StartDate}}</div>
                    <div style="text-align: right;">{{row.EndDate}}</div>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row style="padding-left: 20px;">
                <v-flex xs12>
                  <div style="text-align: right; font-size: 12px;" v-if="row.Entrepreneur">{{row.Entrepreneur.FullName}}</div>
                </v-flex>
              </v-layout>
              <v-layout row style="padding-left: 20px;">
                <v-flex xs6>
                </v-flex>
                <v-flex xs4>
                </v-flex>
                <v-flex xs1 v-if="$root.isCustomer">
                  <v-icon @click="$parent.edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
                </v-flex>
                <v-flex xs1 v-if="$root.isCustomer">
                  <v-icon @click="$parent.confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </div>
      </div>
      <div fluid v-else>
        <h3 style="padding-top: 40px;text-align:center;">אין נתונים</h3>
      </div>
    </div>
</template>

<script>

  import { db } from '../firebase';
  var projectsRef = db.ref('Projects');
  import noImg from '../assets/no_image.png';

  export default {
    name: 'TableProjects',
    data() {
      return {
      }
    },
    created() {
      this.$Log("Vue [TableProjects] is created ...");
    },
    ready() {
      this.$Log("Vue [TableProjects] is ready ...");
    },
    mounted() {
      this.$Log("Vue [TableProjects] is mounted ...");
    },
    updated() {
      this.$Log("Vue [TableProjects] is updated ...");
    },
    methods: {
      imageError(row) {
        row.Images[0] = noImg;
      },
    }
  }

</script>
<style>

  .progress-circular__info {
    color: #000;
  }


</style>



// WEBPACK FOOTER //
// TableProjects.vue?61678021